import { AppAnimate, AppCard, AppGridContainer, AppInfoView } from "@crema";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getBannerDetail } from "redux/actions/Master";
import { AppState } from "redux/store";
import BannerCreate from "./bannerUpdate";
import BannerHeader from "./bannerUpdateHeader";

const BannerUpdatIndex: React.FC = () => {
  const dispatch = useDispatch();
  const { id } = useParams<{ id?: string }>() || {};
  const bannerId = id ? Number(id) : undefined;
  const { currentBanner } = useSelector<AppState, AppState["master"]>(
    ({ master }) => master
  );

  useEffect(() => {
    dispatch({ type: "RESET_BANNER" });

    if (bannerId !== undefined) {
      setTimeout(() => {
        dispatch(getBannerDetail(bannerId));
      }, 1);
    }
  }, [dispatch, bannerId]);

  return (
    <>
      <AppAnimate animation="transition.slideUpIn" delay={200}>
        <AppCard>
          {currentBanner ? (
            <>
              <BannerHeader banner={currentBanner} />
              <AppGridContainer>
                <BannerCreate Banner={currentBanner} />
              </AppGridContainer>
            </>
          ) : (
            <p>Loading...</p> 
          )}
        </AppCard>
      </AppAnimate>
      <AppInfoView />
    </>
  );
};

export default BannerUpdatIndex;
